
import React from 'react'
import {mdx} from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
/* @jsxFrag mdx.Fragment */
import withLayout from 'nextra-theme-mui-docs';
import {withSSG} from 'nextra/ssg';
import layoutConfig from '/vercel/path0/docs/theme.config.js';
import CodeExample from 'nextra-theme-mui-docs/CodeExample';
import Basic from '../../../examples/DataGrid/Basic';
import srcBasic from '../../../examples/DataGrid/Basic?raw';
import Controlled from '../../../examples/DataGrid/Controlled';
import srcControlled from '../../../examples/DataGrid/Controlled?raw';
const MDXLayout = function NextraPage(props) {
  return withSSG(withLayout({
    filename: "index.mdx",
    route: "/components/DataGrid",
    meta: {
      "title": "Basic Usage",
      "description": "Lorem ipsum dolor sit amet.",
      "order": ["index"]
    },
    pageMap: [{
      "name": "component-api",
      "children": [{
        "name": "DataFilter",
        "route": "/component-api/DataFilter"
      }, {
        "name": "DataGrid",
        "route": "/component-api/DataGrid"
      }, {
        "name": "Sparkbars",
        "route": "/component-api/Sparkbars"
      }, {
        "name": "Sparkline",
        "route": "/component-api/Sparkline"
      }],
      "route": "/component-api"
    }, {
      "name": "components",
      "children": [{
        "name": "DataFilter",
        "route": "/components/DataFilter",
        "frontMatter": {
          "title": "DataFilter"
        }
      }, {
        "name": "DataGrid",
        "children": [{
          "name": "columns",
          "route": "/components/DataGrid/columns",
          "frontMatter": {
            "title": "Columns"
          }
        }, {
          "name": "index",
          "route": "/components/DataGrid",
          "frontMatter": {
            "title": "Basic Usage",
            "description": "Lorem ipsum dolor sit amet.",
            "order": ["index"]
          }
        }, {
          "name": "virtualization",
          "route": "/components/DataGrid/virtualization",
          "frontMatter": {
            "title": "Virtualization",
            "description": "Lorem ipsum dolor sit amet."
          }
        }],
        "route": "/components/DataGrid"
      }, {
        "name": "SelectionList",
        "route": "/components/SelectionList",
        "frontMatter": {
          "title": "Introduction",
          "hidden": true
        }
      }, {
        "name": "Sparkbars",
        "route": "/components/Sparkbars",
        "frontMatter": {
          "title": "Sparkbars"
        }
      }, {
        "name": "Sparkline",
        "route": "/components/Sparkline",
        "frontMatter": {
          "title": "Sparkline"
        }
      }, {
        "name": "visx",
        "route": "/components/visx"
      }],
      "route": "/components"
    }, {
      "name": "index",
      "route": "/",
      "frontMatter": {
        "title": "Introduction",
        "order": ["index", {
          "name": "components",
          "title": "Components"
        }, {
          "name": "component-api",
          "title": "Component Api"
        }, {
          "name": "more",
          "title": "More"
        }]
      }
    }, {
      "name": "more",
      "children": [{
        "name": "markdown",
        "route": "/more/markdown",
        "frontMatter": {
          "hidden": true
        }
      }, {
        "name": "nextra-theme-mui-docs",
        "route": "/more/nextra-theme-mui-docs"
      }],
      "route": "/more"
    }]
  }, layoutConfig))(props);
};
function MDXContent({components, ...props}) {
  return <MDXLayout components={components} {...props}><h1>{"DataGrid"}</h1><p>{"The philosophy behind the "}<inlineCode parentName="p">{"mui-plus"}</inlineCode>{" datagrid is to have component that is only concerned with the layout part of the grid. Pagination, filtering, sorting, etc... is best left to the application as it is often highly dependent on the use case. This library focuses on providing a grid component that is focused on layout, column sizing, virtualization, etc... It will never add features that can be implemented externally. If you need a well supported, feature-rich datagrid, please use the "}<a href="https://next.material-ui.com/components/data-grid/" parentName="p"><inlineCode parentName="a">{"Material UI DataGrid"}</inlineCode></a>{"."}</p><h2>{"Uncontrolled"}</h2><p>{"The Grid component works both in uncontrolled mode and controlled mode. To use it in uncontrolled mode, pass column definitions to the "}<inlineCode parentName="p">{"defaultColumns"}</inlineCode>{" prop."}</p>{"\n"}<CodeExample src={srcBasic} mdxType="CodeExample"><Basic parentName="CodeExample" mdxType="Basic" /></CodeExample><h2>{"Controlled"}</h2><p>{"If you want to manipulate the grid component from the outside, You can use the "}<inlineCode parentName="p">{"columns"}</inlineCode>{" and "}<inlineCode parentName="p">{"onColumnsChange"}</inlineCode>{" props to switch the column definition in controlled mode."}</p>{"\n"}<CodeExample src={srcControlled} mdxType="CodeExample"><Controlled parentName="CodeExample" mdxType="Controlled" /></CodeExample></MDXLayout>;
}
MDXContent.isMDXComponent = true;
export default MDXContent;
